import { BaseCartState } from '../cart-state/base-cart-state';
import { ICartState } from '../state-interfaces/i-cart-state';
import createGlobalStateDataAction from './global-state-data-action';

export default createGlobalStateDataAction<ICartState>('CARTSTATE', BaseCartState);